import headNavBarComponent from "./headNavBar.vue";

const headNavBar = {
  install: function(Vue) {
    Vue.component("headNavBar", headNavBarComponent);
  },
};
export default headNavBar;
